import { render, staticRenderFns } from "./AzDistributorsList.vue?vue&type=template&id=d0c9247e"
import script from "./AzDistributorsList.vue?vue&type=script&lang=js"
export * from "./AzDistributorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports